(function () {
    'use strict';

    angular.module("imApp").factory("metaColumnsService", ['$ihttp', function ($ihttp) {
        let service = {
            listMetaColumns: function (parms) {
                return $ihttp.post({
                    method: 2383,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
